import { types } from '../../ducks/App';

export default {
  [types.SHOW_SIDEBAR]: { category: 'ui', action: 'show-sidebar' },
  [types.SHOW_USER_MENU]: { category: 'ui', action: 'show-user-menu' },
};
